var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsPlatformIconPc = function SvgNewcsPlatformIconPc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_platform_icon_pc_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M814 572h18v18h-18z",
    "data-name": "\\u77E9\\u5F62 208",
    opacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_platform_icon_pc_svg__a)",
    transform: "translate(-814 -572)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#807997",
    d: "M823.193 575.155v5.268H830V574Zm0 11.711L830 588v-6.419h-6.807ZM816 580.421h5.754v-5.075l-5.754.976Zm0 5.3 5.754.959v-5.099H816Z",
    "data-name": "\\u8DEF\\u5F84 478"
  }))));
};
export default SvgNewcsPlatformIconPc;